import { render, staticRenderFns } from "./productsmargin.vue?vue&type=template&id=e661de76&"
import script from "./productsmargin.vue?vue&type=script&lang=js&"
export * from "./productsmargin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports